var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hixianchang-previewbox"},[(_vm.pre == 1)?_c('div',{staticClass:"hixianchang-band"},[_c('img',{attrs:{"src":require("../images/hixianchang_iphone.png")}})]):_vm._e(),(_vm.pre == 2)?_c('div',{staticClass:"hixianchang-band-pc"},[_vm._v(_vm._s(_vm.$t('lang.k_154001')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }